<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { CommentsType } from '.';
import { AggregateBlueprint } from '@/components/builder/base/blueprints/AggregateBlueprint';
import { DetailsBuilderContract } from '@/components/builder/details';
import Comments from '@/modules/logito/office/components/Comments.vue';
import properties from '../../properties';

defineOptions({
    name: 'CommentsBlueprint',
    components: {
        ...properties,
    },
});

const props = defineProps({
  "blueprint": null,
  "details": null,
  "parent": null
});

const route = useRoute();

const blueprint = computed(() => props.blueprint);
const licence = computed(() => route.params.licence as string);
const publicId = computed(() => route.params.publicId as string);
const design = computed(() => props.details.designMode());
</script>

<template>
    <dynamic-details-component-wrapper :details="details" :parent="parent" :blueprint="blueprint">
        <template #default>
            <comments
                :blueprint-name="blueprint.name"
                :blueprint-id="blueprint.id"
                :design="design"
                :object-id="publicId"
                :module-name="licence"
                :max-attachments="blueprint.maxAttachments"
                :max-attachment-size-mb="blueprint.maxAttachmentSizeMb"
            />
        </template>
        <template #properties>
            <field-name v-model="blueprint.name" />
            <dynamic-details-accordion>
                <dynamic-details-accordion-item icon="far fa-table" :header="$t('[[[Prezentacja]]]')" :open="true">
                    <field-visible :details="details" :blueprint="blueprint" />
                    <field-numeric
                        v-model="blueprint.maxAttachments"
                        :label="$t('[[[Maksymalna liczba załączników na komentarz]]]' )"
                        :min="0"
                        :max="20"
                    />
                    <field-numeric
                        v-model="blueprint.maxAttachmentSizeMb"
                        :label="$t('[[[Maksymalny rozmiar załącznika (MB)]]]' )"
                        :min="1"
                        :max="100"
                    />
                </dynamic-details-accordion-item>
            </dynamic-details-accordion>
        </template>
    </dynamic-details-component-wrapper>
</template>
